import * as ACTION from './constants';
import * as saga from './saga';
import {takeLatest} from 'redux-saga/effects';

export default function* () {
	yield takeLatest(ACTION.FETCH_INVENTORY.REQUEST, saga.fetchInventoryRequest);
	yield takeLatest(ACTION.FETCH_INVENTORY.SUCCESS, saga.fetchInventorySuccess);
	yield takeLatest(ACTION.FETCH_INVENTORY.FAILED, saga.fetchInventoryFailed);
}
